<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 預約單
    .abilityGroup__item
      span.abilityGroup__subtitle 預約單頁面
      BaseAbilityRadioGroup(
        :value="abilityReservation"
        :disabled="disabled"
        @handleRadioChange="setAbilityReservation")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityReservation: 'positionStore/getCurrentAbilityReservation',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityReservation: 'positionStore/setAbilityReservation',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupReservation.vue